import React, {Component} from 'react';
import TeamLogo from './TeamLogo';
import DataContainer from './data/data';
import { Subscribe} from 'unstated';

class Detail extends Component {
    render() {
        return (
            <div className="detail">
                <Subscribe to={[DataContainer]}>
                    {(DataContainer) => {
                        const team = DataContainer.getCurrentTeam(); 
                        if(!team) {
                            return '';
                        }
                        const currentRound = DataContainer.getCurrentRound();
                        const boldStyle = {fontWeight: 'bold'};
                        // var teamData = JSON.stringify(team, undefined, 2);
                        // teamData = teamData.substr(2,teamData.length-4);
                        return (
                        <div style={{width: '900px', margin: 'auto', wordBreak:'break-all'}}>
                            <div style={{display:'flex', justifyContent: 'center', alignItems: 'center'}}>
                                <TeamLogo team={team} large></TeamLogo>
                                <div style={{paddingLeft: '16px'}}> 
                                    <h1 style={{marginBottom: '4px'}}>{team.team_seed}. {team.team_name}</h1>
                                    <h3 style={{padding: 0, marginTop:0}}>{team.team_region} Region</h3>
                                </div>
                            </div>
                            <div>
                                <div>slot: {team.team_slot}</div>
                                <div style={{fontWeight:"bold"}}>Projected Win Probability:</div>
                                <ul className="win-table">
                                    <li style={currentRound === 1 ? boldStyle : {}}>
                                        Round 1: {Math.floor(team.rd1_win * 100)}% {team.rd1_win === 1 ? ("(won)") : team.rd1_win === 0 ? "(lost)" : ""}
                                    </li><li style={currentRound === 2 ? boldStyle : {}}>
                                        Round 2: {Math.floor(team.rd2_win * 100)}% {team.rd2_win === 1 ? ("(won)") : team.rd2_win === 0 && team.rd1_win > 0 ? "(lost)" : ""} 
                                    </li><li style={currentRound === 3 ? boldStyle : {}}>
                                        Round 3: {Math.floor(team.rd3_win * 100)}% {team.rd3_win === 1 ? ("(won)") : team.rd3_win === 0 && team.rd2_win > 0 ? "(lost)" : ""}
                                    </li><li style={currentRound === 4 ? boldStyle : {}}>
                                        Round 4: {Math.floor(team.rd4_win * 100)}% {team.rd4_win === 1 ? ("(won)") : team.rd4_win === 0 && team.rd3_win > 0 ? "(lost)" : ""}
                                    </li><li style={currentRound === 5 ? boldStyle : {}}>
                                        Round 5: {Math.floor(team.rd5_win * 100)}% {team.rd5_win === 1 ? ("(won)") : team.rd5_win === 0 && team.rd4_win > 0 ? "(lost)" : ""}
                                    </li><li style={currentRound === 6 ? boldStyle : {}}>
                                        Round 6: {Math.floor(team.rd6_win * 100)}% {team.rd6_win === 1 ? ("(won)") : team.rd6_win === 0 && team.rd5_win > 0 ? "(lost)" : ""}
                                    </li><li style={currentRound === 7 ? boldStyle : {}}>
                                        Round 7: {Math.floor(team.rd7_win * 100)}% {team.rd7_win === 1 ? ("(won)") : team.rd7_win === 0 && team.rd6_win > 0 ? "(lost)" : ""}
                                    </li>
                                </ul>
                            </div>

                            {/* <pre style={{margin:'-8px'}}>{teamData}</pre> */}
                        </div>
                    );}}
                </Subscribe>
            </div>
        );
    }
}

export default Detail;